import React from 'react';
import { Field, reduxForm } from 'redux-form'

import Text from './fields/text';
import Textarea from './fields/textarea';
import Image from './fields/image';
import Html from './fields/html';
import Gallery from './fields/gallery';
import Zip from './fields/zip';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';
import Check from "./fields/check";

const required = value => value ? undefined : "Required"


const renderTextField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    lang,
    multilang
}) => (

        <Text
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            multilang={multilang}
            lang={lang}

            {...input}
        />
    )
const renderCheckBox= ({
                           input,
                           label,
                       }) => (
    <Check label={label} {...input} />
)
const renderTextareaField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    lang,
    multilang

}) => (

        <Textarea
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            multilang={multilang}
            lang={lang}

            {...input}
        />
    )

const renderHtmlField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    lang,
    multilang

}) => (

        <Html
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            multilang={multilang}
            lang={lang}

            {...input}
        />
    )

const renderImageField = ({
    input,
    placeholder,
    meta: { touched, error },
}) => (

        <Image
            placeholder={placeholder}
            errorText={touched && error}
            error={touched && error}

            {...input}
        />
    )
const renderZipField = ({
    input,
    placeholder,
    meta: { touched, error },
}) => (

        <Zip
            placeholder={placeholder}
            errorText={touched && error}
            error={touched && error}

            {...input}
        />
    )

const renderGalleryField = ({
    input,
    placeholder,
    label,
    meta: { touched, error },
    lang,
    multilang
}) => (

        <Gallery
            placeholder={placeholder}
            label={label}
            errorText={touched && error}
            error={touched && error}
            lang={lang}
            multilang={multilang}
            {...input}
        />
    )

const form = (props) => {
    const { handleSubmit, pristine, reset, submitting } = props;
    console.log(pristine, submitting);

    return (
        <form onSubmit={handleSubmit}>
            <Row>
                <Col lg="12" >
                    <Container fluid className="form-box">
                        <Row>
                            <Col lg="12">
                                <h3 className="title">Igrica</h3>
                                <h6 className="subtitle">Unesite informacije</h6>
                            </Col>

                            <Col lg="6">
                                <Row>
                                    <Col lg="12" className="input-wrap">
                                        <Field
                                            name="name"
                                            component={renderTextField}
                                            label={"Naziv"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}
                                        ></Field>
                                    </Col>

                                    <Col lg="12" className="input-wrap">
                                        <Field
                                            name="shortDescription"
                                            component={renderTextareaField}
                                            label={"Kratki opis"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}
                                        ></Field>
                                    </Col>
                                    <Col lg="12" className="input-wrap">
                                        <Field
                                            name="description"
                                            component={renderTextareaField}
                                            label={"Opis"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}
                                        ></Field>
                                    </Col>
                                    <Col lg="6" className="input-wrap">
                                        <Field
                                            name="buttonText"
                                            component={renderTextField}
                                            label={"Button text"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}

                                        ></Field>


                                    </Col>

                                    <Col lg="12" className="input-wrap">
                                        <h6 className="title">Tip rezultata</h6>
                                        <Field
                                            name="scoreTime"
                                            component={renderCheckBox}
                                            label={"Vrijeme"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}
                                        ></Field>
                                        <Field
                                            name="scoreNumber"
                                            component={renderCheckBox}
                                            label={"Bodovi"}
                                            placeholder=""
                                            multilang
                                            lang={props.lang}
                                        ></Field>

                                    </Col>

                                    

                                </Row>
                            </Col>
                            <Col lg="3" className="input-wrap">
                                <Field
                                    name="buttonLink"
                                    component={renderZipField}
                                    placeholder=""
                                    lang={props.lang}
                                ></Field>
                            </Col>
                            <Col lg="3" className="input-wrap">
                                <Field
                                    name="image"
                                    component={renderImageField}
                                    placeholder=""
                                    lang={props.lang}
                                ></Field>
                            </Col>
                        </Row>
                    </Container>
                </Col>






                <Col lg="12">
                    <button className="button">Spremi</button>

                </Col>

            </Row>

        </form>
    )
}

export default reduxForm({
    form: 'form'  // a unique identifier for this form
})(form)
